'use strict';

var _toConsumableArray = require("/var/www/honeyguideapps_guides/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/var/www/honeyguideapps_guides/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var deburr = require('lodash.deburr');

var escapeStringRegexp = require('escape-string-regexp');

var builtinReplacements = require('./replacements');

var builtinOverridableReplacements = require('./overridable-replacements');

var decamelize = function decamelize(string) {
  return string.replace(/([a-z\d])([A-Z])/g, '$1 $2').replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1 $2');
};

var doCustomReplacements = function doCustomReplacements(string, replacements) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = replacements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref3 = _step.value;

      var _ref2 = _slicedToArray(_ref3, 2);

      var key = _ref2[0];
      var value = _ref2[1];
      string = string.replace(new RegExp(escapeStringRegexp(key), 'g'), value);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return string;
};

var removeMootSeparators = function removeMootSeparators(string, separator) {
  return string.replace(new RegExp("".concat(separator, "{2,}"), 'g'), separator).replace(new RegExp("^".concat(separator, "|").concat(separator, "$"), 'g'), '');
};

module.exports = function (string, options) {
  if (typeof string !== 'string') {
    throw new TypeError("Expected a string, got `".concat(typeof string, "`"));
  }

  options = Object.assign({
    separator: '-',
    lowercase: true,
    decamelize: true,
    customReplacements: []
  }, options);
  var separator = escapeStringRegexp(options.separator);
  var customReplacements = new Map([].concat(_toConsumableArray(builtinOverridableReplacements), _toConsumableArray(options.customReplacements), _toConsumableArray(builtinReplacements)));
  string = doCustomReplacements(string, customReplacements);
  string = deburr(string);
  string = string.normalize('NFKD');

  if (options.decamelize) {
    string = decamelize(string);
  }

  var patternSlug = /[^a-zA-Z\d]+/g;

  if (options.lowercase) {
    string = string.toLowerCase();
    patternSlug = /[^a-z\d]+/g;
  }

  string = string.replace(patternSlug, separator);
  string = string.replace(/\\/g, '');
  string = removeMootSeparators(string, separator);
  return string;
};